import type React from 'react'

import { clsJoin } from '@/utils'
import css from './styles.module.css'

interface Props {
  img: string
  title: string
  description: string
}

export const UpgradeCarouselItem: React.FC<Props> = ({
  img,
  title,
  description,
}) => {
  const hasText = title || description
  const textWrapCn = clsJoin(
    css.carousel_text_wrap,
    !hasText && css.carousel_text_wrap_hidden
  )

  return (
    <div className={css.carousel_item}>
      <div className={css.carousel_img_wrap}>
        <img src={img} className={css.carousel_img} alt="" />
      </div>

      <div className={textWrapCn} aria-hidden={!hasText}>
        <div className={css.carousel_title}>{title}</div>
        <div className={css.carousel_description}>{description}</div>
      </div>
    </div>
  )
}
